import { render, staticRenderFns } from "./RecursiveMenuItem.vue?vue&type=template&id=69298d27&scoped=true&"
import script from "./RecursiveMenuItem.vue?vue&type=script&lang=js&"
export * from "./RecursiveMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveMenuItem.vue?vue&type=style&index=0&id=69298d27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69298d27",
  null
  
)

export default component.exports